module.exports = __webpack_public_path__ + "259c9ed4085438c3885cd938cc5f58b5.MP3";